import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input, Select} from 'Components/Form';
import {Link} from 'Components/Utilities';

import Auth from 'Services/Api/Auth/Auth';
import GroupsApi from 'Services/Api/Groups/Groups';

import {translation} from 'Services/TranslationHelpers';

class Login extends React.Component {
    /**
     * @var state
     */
    state = {
        groupName: null
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {groupName} = this.state;
        const {form, handleInput, getFieldError, handleSubmit, working, alert} = this.props;

        // Set the column that the user will login with. Email if admin else set by config.
        let login_column = form?.admin_login ? 'email' : window.base.login_column;

        // Do not display the group selector by default.
        let display_group_selector = false;

        // If the login_column config is an array then it indicates that it depends on the user-group
        // so display the group-selector and set the login_column according to the selected group.
        if (typeof login_column === 'object') {
            display_group_selector = true;
            login_column = groupName ? login_column[groupName] : null;
        }

        return (
            <Unauthenticated
                header={false}
                extraClasses={'flex flex-col justify-center items-center w-full'}
                logo={true}
            >
                <AuthLayout
                    title={translation('auth_frontend', 'login')}
                    backLink={window.base.features.allow_password_resets ? "/password/request" : null}
                    backLinkText={translation('auth_frontend', 'forgot_your_password')}
                    submitText={translation('auth_frontend', 'login')}
                    onSubmit={(e) => handleSubmit(e, Auth.login)}
                    working={working}
                    alert={alert}
                >
                    {display_group_selector &&
                        <Select
                            containerClassName="mb-4"
                            label="Group"
                            value={form.group_id}
                            onChange={(v) => {
                                handleInput('group_id', v.id);
                                this.setState({groupName: v.name});
                            }}
                            isAsync
                            searchCallback={(data) => GroupsApi.get(null, {
                                ...data,
                                hasNoTeam: true
                            })}
                            searchLabelKey="name"
                            allowNull={false}
                            returnObject={true}
                        />
                    }

                    {login_column &&
                        <>
                            <Input
                                containerClassName="mb-4"
                                label={translation('auth_frontend', login_column)}
                                type={login_column === "email" ? "email" : null}
                                value={form[login_column]}
                                onChange={v => handleInput(login_column, v)}
                            />

                            <Input
                                label={translation('auth_frontend', 'password')}
                                type="password"
                                value={form.password}
                                onChange={v => handleInput('password', v)}
                            />
                        </>
                    }
                </AuthLayout>

                {window.base.login_column !== 'email' &&
                    <p
                        className="text-sm text-teal-500 cursor-pointer text-center mt-4"
                        onClick={() => handleInput('admin_login', !form?.admin_login)}
                    >
                        {form?.admin_login ?
                            'Return To Login' :
                            'Admin Login'}
                    </p>
                }

                {window.base.features.allow_registrations &&
                    <p className="text-center mt-4">
                        <Link to="/register" colour="text-white">
                            {translation('auth_frontend', 'register_here')}
                        </Link>
                    </p>
                }
            </Unauthenticated>
        );
    }
}

export default FormHandler(Login);
